// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchConfiguration } from 'routes/tax/actions/taxConfig';
import { save as saveUser } from 'client/actions/user';
import { setSelectedBenefits } from 'routes/tax/actions/taxBenefits';
import { getReplacementArgs } from 'routes/tax/components/benefits/utils';

import PayoffPage from './payoffPage';

const BENEFIT_LIST_PREFIX = 'taxes.benefits.taxBenefits';
const SMS_KEY = 'drive-app-link';

const mapStateToProps = (state) => {
  const brand = _.get(state, 'brand');
  const smsReceived = _.get(state, 'sms.received', []);
  const smsSuccess = _.find(smsReceived, { key: SMS_KEY });
  const taxBenefits = _.get(state, 'taxBenefits');
  const taxConfig = _.get(state, 'taxConfig');
  const translations = _.get(state, 'translations');
  const translationOffers = _.get(translations, BENEFIT_LIST_PREFIX, {});
  const user = _.get(state, 'user');
  const isSuperHost = _.get(user, 'settings.isSuperHost') === true;
  const hostText = getReplacementArgs(isSuperHost);
  const allBenefits = _.map(translationOffers, (val: Object, key: string) => ({
    ...val,
    id: key,
  }));
  // if none selected, consider all to be selected
  const selectedBenefits = taxBenefits.length
    ? allBenefits.filter(({ id }) => taxBenefits.includes(id))
    : [...allBenefits];

  return {
    allBenefits,
    brand,
    hostText,
    isSuperHost,
    selectedBenefits,
    smsSuccess,
    taxConfig,
    translations,
    user,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchConfiguration,
    saveUser,
    setSelectedBenefits,
  },
)(PayoffPage);
